import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { waLink } from "@/lib/api";

const BULLETS = [
  "Cashless tie-ups",
  "Zero paperwork stress",
  "100% genuine parts in claim repairs — no duplicates, ever",
];

export default function Insurance() {
  return (
    <section id="insurance" className="py-16 sm:py-28 px-5 lg:px-8 bg-[#F5F5F7] border-y border-[#E4E4E7]" data-testid="insurance-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-[auto_1fr] gap-8 items-start">
        <div className="hidden lg:flex w-20 h-20 rounded-sm bg-white border border-[#E4E4E7] items-center justify-center">
          <ShieldCheck className="w-10 h-10 text-[#FF5A00]" />
        </div>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <p className="text-xs uppercase tracking-[0.25em] text-[#FF5A00] font-bold mb-3">Insurance Claims</p>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-[#0A0A0A] max-w-2xl">
            Accident? We Handle Your Insurance Claim — <span className="text-[#FF5A00]">Cashless.</span>
          </h2>
          <p className="mt-5 text-[#52525B] max-w-2xl leading-relaxed">
            AutoHQ manages the full claim for you — survey coordination,
            documentation, approval follow-up, and cashless repair with all
            major insurers. You drop the car; we handle everything else.
          </p>
          <ul className="mt-6 space-y-3">
            {BULLETS.map((b) => (
              <li key={b} className="flex items-start gap-3 text-sm font-semibold text-[#0A0A0A]">
                <span className="text-[#FF5A00] mt-0.5">✓</span> {b}
              </li>
            ))}
          </ul>
          <Button
            data-testid="insurance-whatsapp-cta"
            asChild
            className="mt-8 bg-[#25D366] hover:bg-[#1fb457] text-white font-bold px-6 py-5 rounded-sm"
          >
            <a href={waLink("Hi AutoHQ, I need help with my car insurance claim.")} target="_blank" rel="noopener noreferrer">
              WhatsApp Us Your Claim
            </a>
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
